exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit-form .invalid input, .edit-form .invalid select {\n  border-color: #f00; }\n\n.edit-form input.invalid {\n  border-color: #f00; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader/lib/loader.js!./styles/edit-form.scss
// module id = 553
// module chunks = 0